import * as types from '../mutation-types';

const state = {
    page_name:null
};

const getters = {
    page_name: state=>state.page_name
};

const actions = {
};

const mutations = {
    [types.PAGE_NAME] (state,page){
        state.page_name = page;
    }
};

export {
    state,
    getters,
    actions,
    mutations
};